// extracted by mini-css-extract-plugin
export default {"wrapper":"PotBoosterAnimation-module__wrapper"};